import { DYNAMIC_DIALOG_CONFIG } from '@algomusinc/domain';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AddCommentsComponent } from 'algomusinc/components/src/lib/modules/renderer/components/add-comments/add-comments.component';
import { DialogService, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ApprovalFeedbackComponent } from './approval-feedback/approval-feedback.component';
import { ConfigurationService, ToasterService} from '@algomusinc/services';
@Component({
  selector: 'app-approval-request',
  templateUrl: './approval-request.component.html',
  styleUrls: ['./approval-request.component.css']
})
export class ApprovalRequestComponent implements OnInit {
  public dialogDefaultConfig: DynamicDialogConfig = JSON.parse(DYNAMIC_DIALOG_CONFIG.STATIC)
  requestId: any;

  constructor(
    public dialog: DialogService, public activatedRoute: ActivatedRoute, private config : ConfigurationService,
        public snackbar: ToasterService,) {
    this.requestId = this.activatedRoute.snapshot.params['id'] || '';
  }

  ngOnInit() {
    let params = {
      requestId: this.requestId
    };

    this.config.GetApprovalByRequestId(params).subscribe((res) => {
      if (res) {
        let toastMsg = "";
         if (res == 1) {
        const dialogRef = this.dialog.open(AddCommentsComponent, {
        ...this.dialogDefaultConfig,
        width: '1200px',
        height: '500px',
        header: `Comments`,
        styleClass: 'logs-dialog',
        closable: false,
        data: { requestId: this.requestId, approvalId: 0 }
      });

      dialogRef.onClose.subscribe((result) => {
        if (result) {
          this.openFeedbackDialog(result.status, result.message);
        }
      });
        } else if (res == -1) {
          toastMsg = "Not Found";
          this.openFeedbackDialog(1, toastMsg);
        } else if (res == -2) {
          toastMsg = "Response Url Expired";
          this.openFeedbackDialog(1, toastMsg);
        } else if (res == -3) {
          toastMsg = "This action has already been completed.";
          this.openFeedbackDialog(1, toastMsg);
        } else {
          toastMsg = "Something went wrong";
          this.openFeedbackDialog(1, toastMsg);
        }
      }
    });
      
    
  }

  openFeedbackDialog(status: number, message: string) {
    this.dialog.open(ApprovalFeedbackComponent, {
      header: 'Feedback',
      width: '100vw',
      height: '100vh',
      style: { 'max-width': '100%', 'max-height': '100%' },
      closable: false,
      modal: true,
      data: {
        status: status,
        message: message
      }
    });
  }

}
